import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Grid, Segment, Button, Header, Icon, Tab, Label, Dimmer, Loader, Divider, Form, Modal } from "semantic-ui-react";
import _ from 'lodash';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import QuestionaireSideMenu from './QuestionaireSideMenu';
import QuestionaireSectionComponent from './QuestionaireSectionComponent';
// import LookupsPage from '../../lookupsPage/LookupsPage';
import LookupsQnairePage from '../../lookupsQnairePage/LookupsQnairePage';
import BRQnairePage from '../../brQnairePage/BRQnairePage';
import ApiDocumentationTab from '../ApiDocumentationTab';
import * as EXTERNAL_API_ACTIONS from '../../../../actions/externalApiActions';
import MarketPlaceCategoriesPage from './MarketPlaceCategoriesPage';
import TestQuestionnaireModal from './TestQuestionnaireModal';
import FuseContentModal from '../../../../components/generic/FuseContentModal';
import { hasTranslationWarnings, TranslationWarnings } from './TranslationWarnings';
import { hasTranslationFailure, TranslationFailure } from './TranslationFailure';

import * as TEST_QNAIRE_ACTIONS from "../../../../actions/testQuestionnaireActions"
import * as QUESTIONAIRE_ACTIONS from "../../../../actions/questionaireActions";
import { getTranslationRequestLanguages, TRANSLATION_MODES } from '../../../../constants/translations';

export function StructuredQuestionairePage(props) {
	const history = useHistory();
	const [state, setState] = useState({
		questionaire: { ...props.selectedQuestionaire },
		selectedQuestionaireMainSection: null,
		sections: { ...props.sections },
		fetchingData: false,
		currentPage: 0,
		pageSize: 10,
		isTestModalOpen: false,
		isTranslating: false,
		showTranslationModal: false,
		translationMode: TRANSLATION_MODES.ADDITIVE,
		questionaireFilter: {
			key: "All",
			text: "Filter",
			value: -1
		}
	});

	useEffect(() => {
		if (state.questionaire === undefined || _.isEmpty(state.questionaire)) {
			history.goBack();
		}
	}, []);

	useEffect(() => {
		if (state.selectedQuestionaireMainSection != null) {
			const found = props.sections.find(e => e.id == state.selectedQuestionaireMainSection.id);
			onMainSectionSelected(found);
		}
	}, [props.sections, props.sections.length]);

	const onBack = () => {
		history.goBack();
	}

	const onMainSectionSelected = (section) => {
		setState({ ...state, selectedQuestionaireMainSection: section });
	}

	const translateQuestionnaire = async (translationMode) => {
		setState((currentState) => ({
			...currentState,
			isTranslating: true,
			showTranslationModal: false
		}));

		try {
			// The action locks the local questionnaire synchronously, allowing us to
			// leave this screen while the backend stages the translation request.
			const translationRequest = props.translateQuestionnaire(props.selectedQuestionaire, null, translationMode);
			history.push('/Questionnaires');
			await translationRequest;
			toast.success('Questionnaire translation started. The questionnaire will be unavailable untill the translation is complete.');
		} catch (error) {
			toast.error('Failed to start questionnaire translation. Please try again.');
		}
	}

	const translationModal = () => {
		const configuredTranslationLanguages = getTranslationRequestLanguages(props.selectedQuestionaire);

		return (
			<Modal
				open={state.showTranslationModal}
				onClose={() => setState((currentState) => ({ ...currentState, showTranslationModal: false }))}
				size='small'
			>
				<Modal.Header>Translate questionnaire</Modal.Header>
				<Modal.Content>
					<Form>
						<Form.Radio
							label='Add missing translations (recommended)'
							checked={state.translationMode === TRANSLATION_MODES.ADDITIVE}
							onChange={() => setState((currentState) => ({
								...currentState,
								translationMode: TRANSLATION_MODES.ADDITIVE
							}))}
						/>
						<p>Adds translations only where a value is missing or blank. Existing translations, including manual edits, are preserved.</p>
						<Form.Radio
							label='Re-translate all content'
							checked={state.translationMode === TRANSLATION_MODES.RETRANSLATE}
							onChange={() => setState((currentState) => ({
								...currentState,
								translationMode: TRANSLATION_MODES.RETRANSLATE
							}))}
						/>
						<p>Generates new translations for all content in every configured language. Existing translations, including manual edits, will be overwritten.</p>
					</Form>
				</Modal.Content>
				<Modal.Actions>
					<Button onClick={() => setState((currentState) => ({ ...currentState, showTranslationModal: false }))}>
						Cancel
					</Button>
					<Button
						negative={state.translationMode === TRANSLATION_MODES.RETRANSLATE}
						primary={state.translationMode === TRANSLATION_MODES.ADDITIVE}
						disabled={configuredTranslationLanguages.length === 0}
						onClick={() => translateQuestionnaire(state.translationMode)}
					>
						Start translation
					</Button>
				</Modal.Actions>
			</Modal>
		);
	};

	const questionaireHeader = () => {
		if (!_.isEmpty(state.questionaire) && !_.isEmpty(state.questionaire.status)) {
			return (
				<Grid.Row>
					<Grid.Column width={4}>
						<h2>{state.questionaire.name}</h2>
					</Grid.Column>
					<Grid.Column width={12}>
						<div style={{ float: "right" }}>
							<Label
								color={state.questionaire.status === "active" ? 'green' : state.questionaire.status === "underReview" ? 'yellow' : state.questionaire.status === "translating" ? 'yellow' : state.questionaire.status === "denied" ? 'red' : 'red'}
							>
								{state.questionaire.status === "active" ? 'Active' : state.questionaire.status === "underReview" ? 'Under Review' : state.questionaire.status === "translating" ? 'Translation In Progress' : state.questionaire.status === "denied" ? 'Denied' : 'Inactive'}
							</Label>
							<Label color="blue">Category: {state.questionaire.questionaireType}</Label>
							{(state.questionaire.defaultQuestionnaire === true) &&
								(<Label color='green'>Default</Label>)}
							<FuseContentModal
								header={`Test ${state.questionaire.name}`}
								content={<TestQuestionnaireModal questionaire={props.selectedQuestionaire} />}
								trigger={<Button size='mini' className='primary'> Test Questionnaire</Button>}
								onClose={() => {
									let qnaireData = {
										PK: `USER#${props.userData[0].userName}`,
										SK: `QNAIRE#${props.selectedQuestionaire.id}`,
										status: "isDeleted"
									}

									props.deleteTestQnaireAction(qnaireData);
								}}
							/>
							{((props.selectedQuestionaire.translateQnaire) &&
								<Button
									size='mini'
									className='primary'
									loading={state.isTranslating}
									disabled={state.isTranslating}
									onClick={() => setState((currentState) => ({
										...currentState,
										showTranslationModal: true,
										translationMode: TRANSLATION_MODES.ADDITIVE
									}))}
								>
									Translate Questionnaire
								</Button>
							)}
						</div>
					</Grid.Column>
				</Grid.Row>
			);
		}
	};

	const activationRuleHeader = () => {
		return (
			<Grid.Row>
				<Grid.Column width={8}>
					<h2>Distribution Rules:</h2>
				</Grid.Column>
			</Grid.Row>
		);
	};


	const sectionContent = () => {
		if (!props.fetchingData) {
			if (!_.isEmpty(state.selectedQuestionaireMainSection))
				return (
					<Grid.Column width={12}>
						<Segment>
							<QuestionaireSectionComponent section={state.selectedQuestionaireMainSection} questionaire={state.questionaire}
								header={`${state.selectedQuestionaireMainSection.displayName}`} onSectionDeleted={() => onMainSectionSelected({})}
							/>
						</Segment>
					</Grid.Column>
				);
			else {
				return (
					<Grid.Column width={12}>
						<Segment placeholder vertical>
							<Header>
								<div style={{ textAlign: "center" }}>
									<Icon name="pointing left" size="large" color="grey"></Icon><span style={{ color: "#a9a9a9" }}>Select a section on the left to view its content</span>
								</div>
							</Header>
						</Segment>
					</Grid.Column>
				);
			}
		}
		else {
			return (
				<div style={{ height: "300px", }}>
					<Dimmer inverted active>
						<Loader content='Loading' />
					</Dimmer>
				</div>
			);
		}
	}

	const questionaire = () => {
		if (state.questionaire && !_.isEmpty(state.questionaire)) {

			const panes = [
				{
					menuItem: 'Questionnaire Details',
					render: () =>
						<Tab.Pane attached={true}>
							<Grid>
								{questionaireHeader()}
								<Divider />
								<Grid.Row columns="2" stretched>
									<Grid.Column width={3}>
										<QuestionaireSideMenu questionaire={state.questionaire} onSelectionChanged={onMainSectionSelected} />
									</Grid.Column>
									{sectionContent()}
								</Grid.Row>
							</Grid>
						</Tab.Pane>,
				},
				// {
				// 	menuItem: 'Lookup Values',
				// 	render: () =>
				// 		<Tab.Pane attached={true}>
				// 			<Grid>
				// 				{questionaireHeader()}
				// 				<LookupsPage questionaire={state.questionaire} />
				// 			</Grid>
				// 		</Tab.Pane>,
				// },
				{
					menuItem: 'Lookup Menu/Link to Questionnaire Values',
					render: () =>
						<Tab.Pane attached={true}>
							<Grid>
								{questionaireHeader()}
								<LookupsQnairePage questionaire={state.questionaire} />
							</Grid>
						</Tab.Pane>,
				},
				{
					menuItem: 'Link to Business Rule/s',
					render: () =>
						<Tab.Pane attached={true}>
							<Grid>
								{questionaireHeader()}
								<BRQnairePage questionaire={state.questionaire} />
							</Grid>
						</Tab.Pane>,
				},
			];

			// Add API Documentation tab
			const hasExternalApiPermission = (!_.isEmpty(props.userPermissions) && props.userPermissions.hasOwnProperty('External API') && props.userPermissions['External API'].actions.READ)
				|| (!_.isEmpty(props.userPermissions) && props.userPermissions.hasOwnProperty('Other') && props.userPermissions['Other'].actions.admin);

			if (hasExternalApiPermission) {
				panes.push({
					menuItem: 'API Documentation',
					render: () =>
						<Tab.Pane attached={true}>
							<Grid>
								{questionaireHeader()}
								<Grid.Row>
									<Grid.Column width={16}>
										<ApiDocumentationTab
											questionnaire={state.questionaire}
											questionnaireToken={state.questionaire.externalApiToken}
											tenantToken={props.externalApi?.tenantApiToken}
											canUpdate={(!_.isEmpty(props.userPermissions) && props.userPermissions.hasOwnProperty('External API') && props.userPermissions['External API'].actions.UPDATE) || (!_.isEmpty(props.userPermissions) && props.userPermissions.hasOwnProperty('Other') && props.userPermissions['Other'].actions.admin)}
											onToggleAccess={async (checked) => {
												try {
													const response = await props.toggleQuestionnaireApiAccess(
														state.questionaire.id,
														state.questionaire.tenantId,
														checked,
														state.questionaire
													);
													setState(prev => ({
														...prev,
														questionaire: {
															...prev.questionaire,
															externalApiEnabled: checked,
															externalApiToken: response.token,
															externalApiTokenCreatedAt: response.createdAt
														}
													}));
													toast.success(checked ? 'External API access enabled' : 'External API access disabled');
												} catch (error) {
													toast.error('Failed to update API access');
												}
											}}
										/>
									</Grid.Column>
								</Grid.Row>
							</Grid>
						</Tab.Pane>,
				});
			}

			// Add Market Place Categories tab only for Community Market Place questionnaires
			if (state.questionaire.questionaireType === "Community Marketplace") {
				panes.push({
					menuItem: 'Marketplace Categories',
					render: () =>
						<Tab.Pane attached={true}>
							<Grid>
								{questionaireHeader()}
								<MarketPlaceCategoriesPage questionaire={state.questionaire} />
							</Grid>
						</Tab.Pane>,
				});
			}

			return (
				<div>
					<Grid>
						<Grid.Row>
							<Grid.Column width={16} floated='left'>
								<Button primary onClick={() => { onBack() }}><Icon name='arrow left' /> Back</Button>
							</Grid.Column>
						</Grid.Row>

						{hasTranslationWarnings(state.questionaire) && (
							<Grid.Row>
								<Grid.Column width={16}>
									<TranslationWarnings questionaire={state.questionaire} />
								</Grid.Column>
							</Grid.Row>
						)}

						{hasTranslationFailure(state.questionaire) && (
							<Grid.Row>
								<Grid.Column width={16}>
									<TranslationFailure questionaire={state.questionaire} />
								</Grid.Column>
							</Grid.Row>
						)}

						<Grid.Row>
							<Grid.Column width={16} floated='left'>
								<Tab menu={{ attached: true, tabular: true }} panes={panes} />
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</div>
			);
		} else return null;
	}

	return (
		<div>
			{questionaire()}
			{translationModal()}
		</div>
	);

}

const mapStateToProps = (state, ownProps) => {
	return {
		userData: state.authUserRoles.userRoles,
		fetchingData: state.fetchingData === true,
		sections: state.sections,
		selectedQuestionaire: _.isEmpty(state.questionaires) ? {} : Object.values(state.questionaires).filter(questionaire => questionaire.id === ownProps.location.state.id)[0],
		selectedQuestionaireMainSection: (_.isEmpty(state.sections) || _.isEmpty(state.uiState) || _.isEmpty(state.uiState.selectedQuestionaireMainSectionId)) ? {} : Object.values(state.sections).filter(x => x.id === state.uiState.selectedQuestionaireMainSectionId)[0],
		externalApi: state.externalApi,
		userPermissions: _.isEmpty(state.authUserRoles.permissions) ? {} : state.authUserRoles.permissions
	};
}

export default connect(
	// map state to props
	mapStateToProps,
	// map dispatch to props
	(dispatch, ownProps) => ({
		deleteTestQnaireAction: (qnaireData) => dispatch(TEST_QNAIRE_ACTIONS.deleteTestQnaireAction(qnaireData)),
		translateQuestionnaire: (questionaire, history, translationMode) => dispatch(QUESTIONAIRE_ACTIONS.translateQuestionaireAction(questionaire, history, translationMode)),
		toggleQuestionnaireApiAccess: (questionnaireId, tenantId, enabled, questionnaire) => dispatch(EXTERNAL_API_ACTIONS.toggleQuestionnaireApiAccess(questionnaireId, tenantId, enabled, questionnaire))
	})
)(StructuredQuestionairePage);
